// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "promoCode__container-3Auql";
var _4 = "promoCode__clear-1LqNY";
var _5 = "promoCode__icon-2Ux2N";
var _6 = "promoCode__iconNotApplied-1UwdC";
var _7 = "promoCodeForm__button-216Ca";
var _8 = "promoCodeForm__codeInput-6U1x3";
var _9 = "promoCodeForm__statusMessage-1D-4T";
var _a = "promoCode__trigger-1G_eL";
export { _1 as "__esModule", _2 as "mobile", _3 as "promoCode__container", _4 as "promoCode__clear", _5 as "promoCode__icon", _6 as "promoCode__iconNotApplied", _7 as "promoCodeForm__button", _8 as "promoCodeForm__codeInput", _9 as "promoCodeForm__statusMessage", _a as "promoCode__trigger" }
export default { "__esModule": _1, "mobile": _2, "promoCode__container": _3, "promoCode__clear": _4, "promoCode__icon": _5, "promoCode__iconNotApplied": _6, "promoCodeForm__button": _7, "promoCodeForm__codeInput": _8, "promoCodeForm__statusMessage": _9, "promoCode__trigger": _a }
